export default __webpack_public_path__ + "static/media/master.4ce81339.png";